import { imageFissionAPI } from '@/utils/api';

export function normalizeFissionBatchStatus(status) {
  const normalized = String(status || 'processing').toLowerCase();
  if (normalized === 'completed') return 'success';
  if (normalized === 'failed') return 'failed';
  if (normalized === 'partial') return 'partial';
  if (['processing', 'running', 'pending', 'waiting'].includes(normalized)) return 'processing';
  return normalized;
}

export function formatFissionBatchAsTask(batch) {
  const firstSource = (batch?.sources || [])[0];
  const firstOutput = (firstSource?.outputs || [])[0];
  const rawId = batch?.id || batch?.batchNo || '';
  const previewFromOutput = firstOutput?.displayUrl || firstOutput?.viewUrl || firstOutput?.url || '';
  const previewFromSource = firstSource?.displayUrl || firstSource?.viewUrl || firstSource?.url || firstSource?.src || '';
  return {
    id: String(rawId),
    subAccount: String(batch?.batchNo || batch?.id || rawId),
    total: batch?.total ?? 0,
    successCount: batch?.successCount ?? 0,
    failedCount: batch?.failedCount ?? 0,
    status: normalizeFissionBatchStatus(batch?.status),
    createdAt: batch?.createdAt,
    operator: batch?.operator,
    previewUrl: previewFromOutput || previewFromSource,
    previewDisplayUrl: previewFromOutput || previewFromSource,
    _rawBatch: batch,
  };
}

export function resolveFissionBatchNo(task) {
  return String(task?.subAccount || task?.id || '');
}

export function resolveFissionHistoryBadgeTaskId(task) {
  return String(task?._rawBatch?.id || task?.subAccount || task?.id || '');
}

export function resolveFissionServerBatchId(task) {
  return String(task?._rawBatch?.id || task?.subAccount || task?.id || '');
}

export async function loadFissionHistoryTasks({ page = 1, pageSize = 20, ownerUserId } = {}) {
  const query = {
    page: Math.max(1, Number(page) || 1),
    pageSize: Math.max(1, Math.min(100, Number(pageSize) || 20)),
  };
  const owner = String(ownerUserId || '').trim();
  if (owner) {
    query.ownerUserId = owner;
  }
  const res = await imageFissionAPI.listBatches(query);
  return {
    tasks: (res?.batches || []).map(formatFissionBatchAsTask),
    total: Number(res?.total) || 0,
  };
}
